<template>
  <div>
    <CDataTable
      class="d-none d-xl-block"
      striped
      small
      :border='false'
      hover
      :loading="isLoading"
      :items="grainWanted"
      :fields="fields"
    >
      <template #loading>
        <div class="text-center">
        <CSpinner color="primary"/>
        </div>
      </template>
      <template #no-items-view>
        <div class="text-center">{{error ? error : "No items"}}</div>  
      </template>

      <template #location="{item}">
        <td>
          {{ item.location || '' }}
        </td>
      </template>
      <template #comment="{item}">
        <td>
          <div v-if="item.comment">
            &ldquo;<i>{{ item.comment }}</i>&rdquo;
          </div>
        </td>
      </template>
      <template #actions="{item, index}">
        <td class="text-right">
          <CButton 
            class="mr-2"
            size="sm" 
            color="primary"
            variant="outline"
            @click.stop="search(item)"
          >
            Search
          </CButton>
          <CButton 
            size="sm" 
            color="primary"
            variant="outline"
            @click.stop="createOffer(item)"
          >
            Create offer
          </CButton>
        </td>
      </template>
    </CDataTable>

    <CDataTable
      class="d-xl-none"
      striped
      small
      :border='false'
      :loading="isLoading"
      :items="grainWanted"
      :fields="[{key: 'single', _classes: 'd-none'}]"
      :items-per-page="10"
      pagination
    >
      <template #loading>
        <div class="text-center">
        <CSpinner color="primary"/>
        </div>
      </template>
      <template #no-items-view>
        <div class="text-center">{{error ? error : "No items"}}</div>  
      </template>
      <template #single="{item}">
        <GrainWantedCard :grainWanted="item" :showDivider="false" />
      </template>
    </CDataTable>
  </div>
</template>

<script>
import offerAPI from '@/api/offer'
import GrainWanted from '@/model/grain-wanted'
import GrainWantedCard from './GrainWantedCard'
import { apiSearchToFilterSearch } from '@/views/search/search.js'

export default {
  name: 'GrainWanted',
  components: {
    GrainWantedCard
  },
  data () {
    return {
      isLoading: false,
      error: null,
      grainWanted: [],
      fields: [
        {key: 'dateCreatedDateOnlyFormatted', label: 'Posted'},
        {key: 'grainLabel', label: 'Grain', _classes: 'strong nowrap'}, 
        {key: 'gradeLabel', label: 'Grade', _classes: 'strong nowrap'}, 
        {key: 'storageTypeLabel', label: 'Storage'},
        'location',
        {key: 'offerTypeLabel', label: 'Type'}, 
        {key: 'priceLabel', label: 'Max. price / mt', _classes: 'strong text-right nowrap'},
        'comment',
        {key: 'actions', _classes: 'text-right'}
      ],
    }
  },
  async mounted () {
    await this.getGrainWanted()
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters['auth/isLoggedIn']
    },
    isAdminUser () {
      return this.$store.getters['auth/isAdminUser']
    }
  },
  methods: {
    createOffer (item) {
      console.log('GrainWanted createOffer', item)
      return this.$router.push({ name: 'Offer flow grain', params: {grainWanted: item} })
    },
    search (item) {
      const filterSearch = apiSearchToFilterSearch(item)
      this.$router.push({ name: 'Search', params: {search: filterSearch} })
    },

    async getGrainWanted() {
      console.log('getGrainWanted')
      this.grainWanted = []
      this.error = null
      this.isLoading = true
      try {
        let result
        if (this.isLoggedIn && this.isAdminUser) {
          result = await offerAPI.getGrainWantedPlus()
        } else {
          result = await offerAPI.getGrainWanted()
        }

        // Break out multiple grains and grades into separate rows
        const grainWanted = []
        result.forEach(item => {
          if (Array.isArray(item.grain) && item.grain.length > 0) {
            item.grain.forEach(grain => {
              if (Array.isArray(grain.grades) && grain.grades.length > 0) {
                grain.grades.forEach(grade => {
                  grainWanted.push(
                    GrainWanted.newFromExisting(grain.name, grade.name, item)
                  )
                })
              } else {
                grainWanted.push(
                  GrainWanted.newFromExisting(grain.name, '', item)
                )
              }
            })
          }
        })

        this.grainWanted = grainWanted
      } catch (e) { 
        console.error(e)
        this.error = e
      }
      this.isLoading = false
    },
  },
}
</script>

<style scoped>
.nowrap {
  white-space: nowrap;
}
.small-text {
  font-size: 95%;
}
</style>

<style>
td.strong {
  font-weight: 500;
}
</style>
